import _construct from "C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/construct";
import _possibleConstructorReturn from "C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import _assertThisInitialized from "C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/assertThisInitialized";
import _wrapNativeSuper from "C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/wrapNativeSuper";
import _classCallCheck from "C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
export var ErrorHandler =
/*#__PURE__*/
function () {
  function ErrorHandler() {
    _classCallCheck(this, ErrorHandler);
  }

  _createClass(ErrorHandler, [{
    key: "SESSION_NOT_FOUND",
    value: function SESSION_NOT_FOUND(index) {
      var name = 'SESSION_NOT_FOUND';
      var message = "Session ID ".concat(index, " Not found in CRATE");

      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return this.getError.apply(this, [name, message].concat(args));
    }
  }, {
    key: "getError",
    value: function getError(name, message) {
      var MyError =
      /*#__PURE__*/
      function (_Error) {
        _inherits(MyError, _Error);

        function MyError(name, message) {
          var _getPrototypeOf2;

          var _this;

          _classCallCheck(this, MyError);

          for (var _len3 = arguments.length, args = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
            args[_key3 - 2] = arguments[_key3];
          }

          _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(MyError)).call.apply(_getPrototypeOf2, [this, message].concat(args)));
          _this.name = name;
          _this.message = message;

          if (typeof Error.captureStackTrace === 'function') {
            Error.captureStackTrace(_assertThisInitialized(_assertThisInitialized(_this)), _this.constructor);
          } else {
            _this.stack = new Error(message).stack;
          }

          return _this;
        }

        return MyError;
      }(_wrapNativeSuper(Error));

      for (var _len2 = arguments.length, args = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      return _construct(MyError, [name, message].concat(args));
    }
  }]);

  return ErrorHandler;
}();